import { useMemo } from 'react';
import FilterBar from '@components/filters/FilterBar';
import OptionFilterPanel from '@components/filters/OptionFilterPanel';
import AgenciesFilterMenuButton from './AgenciesFilterMenuButton';
import {
  FilterState,
  FILTER_OPTIONS,
  getFilterLabels,
  clearByKey,
} from './filterState';

type AgenciesFilterBarProps = {
  filterState: FilterState;
  onFilterChange: (newState: FilterState) => void;
  onClearAll: () => void;
};

const AgenciesFilterBar: React.FC<AgenciesFilterBarProps> = ({ filterState, onFilterChange, onClearAll }) => {
  const filterLabels = useMemo(() => getFilterLabels(filterState), [filterState]);

  const activeFilters = filterLabels.map(({ key, label, value }) => ({
    key,
    label,
    value,
    onDelete: () => onFilterChange(clearByKey(filterState, key)),
    popoverContent: (
      <OptionFilterPanel
        options={FILTER_OPTIONS[key]}
        selected={filterState[key]}
        onChange={(newSelected) => onFilterChange({ ...filterState, [key]: newSelected })}
      />
    ),
  }));

  return (
    <FilterBar
      filterMenuButton={<AgenciesFilterMenuButton filterState={filterState} onFilterChange={onFilterChange} />}
      activeFilters={activeFilters}
      onClearAll={onClearAll}
    />
  );
};

export default AgenciesFilterBar;
